module.exports = __webpack_public_path__ + "static/car11-ceafc07903273ca68deb130cb3fe4b3d.png";